export default __webpack_public_path__ + "static/media/grey-large.beaed141.webp";